import { useCallback, useEffect, useRef } from 'react';
import { type MyOCConfig } from '@cx-web/server-utils/types';

type UseMyOCLoginInitParams = MyOCConfig | null;

export const useMyOCLoginInit = (params: UseMyOCLoginInitParams) => {
  const initiMyOCLogin = useCallback(() => {
    if (!params) return;
    try {
      window.ocRenderers['myoc-login'](params, () => {
        const event = new CustomEvent('OC:ocAuthReady', {});
        window.dispatchEvent(event);
      });
    } catch (e) {
      console.log(e);
    }
  }, [params]);

  const loadMyOCRef = useRef(false);

  const loadMyOCLogin = useCallback(() => {
    if (!params || loadMyOCRef.current) return;

    const script = document.createElement('script');
    script.setAttribute('src', params.bundleUrl);
    script.onload = initiMyOCLogin;
    document.body.appendChild(script);

    loadMyOCRef.current = true;
  }, [params, initiMyOCLogin]);

  useEffect(() => {
    if (document.readyState === 'complete') {
      loadMyOCLogin();
      return;
    }
    const handler = () => loadMyOCLogin();
    window.addEventListener('load', handler);
    return () => window.removeEventListener('load', handler);
  }, [loadMyOCLogin]);

  // Subscribe to OC:events
  useEffect(() => {
    const ocAuthReady = () => {
      // SEE: myoc-login > widget-api > userActionCallback
      window.ocAuth.listenForUserAction((e: any) => {
        const body = document.getElementsByTagName('html')[0];

        switch (e.event) {
          case 'opened':
            body?.classList?.add('body_fixed');
            break;

          case 'login-success': {
            window.dispatchEvent(new CustomEvent('OC:LoggedIn'));
            break;
          }

          case 'close': {
            body?.classList?.remove('body_fixed');
            window.dispatchEvent(new CustomEvent('OC:ModalClosed', {}));
            window.closeAllModals?.();
            break;
          }
        }
      });
    };

    window.addEventListener('OC:ocAuthReady', ocAuthReady);

    return () => {
      window.removeEventListener('OC:ocAuthReady', ocAuthReady);
    };
  }, []);
};
